import Vue from 'vue'
import App from './App.vue'
import { store } from "./store";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/normalize.css'
import './assets/css/main.css'
import './assets/css/utilities/extra-styles-bootstrap.css'
import axios from 'axios'
import Vuelidate from 'vuelidate'

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

// Defining some axios constant parameters that won't change in any request
axios.defaults.baseURL = store.getters.getBaseURL + 'crud/';
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json'
};

new Vue({
  el: '#app',
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js